import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { styles } from './protected-time-list.styles';
import { Flex, IconButton, Input, Select, Text } from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const ProtectedTimeList = (props)=>{
    const { dayEditDisabled, protectedTimeDayDict, handleUpdateProtectedTime, handleDeleteProtectedTime, setProtectedTimeDayDict, statusList } = props;
    const classes = styles();
    const checkProtectedTimeOverlap = (protectedTimeEntry)=>{
        // check if startTime + duration = endTime falls after startTime of any other event
        const endTime = new Date(protectedTimeEntry.startTime);
        endTime.setTime(endTime.getTime() + protectedTimeEntry.duration * 60 * 60 * 1000);
        return Object.values(protectedTimeDayDict).some((protectedTime)=>new Date(protectedTimeEntry.startTime) < new Date(protectedTime.startTime) && new Date(protectedTime.startTime) < endTime);
    };
    const updateDurationProtectedTimeEntry = (protectedTime, event)=>{
        const { target } = event;
        const updatedProtectedTimeEntry = {
            ...protectedTime
        };
        if (Number.isNaN(target.value)) {
            updatedProtectedTimeEntry.duration = 0;
        } else {
            updatedProtectedTimeEntry.duration = +target.value;
        }
        setProtectedTimeDayDict({
            ...protectedTimeDayDict,
            [protectedTime.workLogId]: updatedProtectedTimeEntry
        });
    };
    return /*#__PURE__*/ _jsx(Flex, {
        direction: "column",
        children: Object.keys(protectedTimeDayDict).map((protectedTimeKey)=>{
            return /*#__PURE__*/ _jsxs(Flex, {
                direction: "column",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        direction: "row",
                        sx: classes['.protectedTimeRowContainer'],
                        children: [
                            /*#__PURE__*/ _jsx(Flex, {
                                sx: classes['.startTimePast'],
                                children: /*#__PURE__*/ _jsx(Input, {
                                    type: 'time',
                                    id: "startTime",
                                    disabled: dayEditDisabled[protectedTimeDayDict[protectedTimeKey].day.toLowerCase()],
                                    value: new Date(protectedTimeDayDict[protectedTimeKey].startTime).toLocaleTimeString([], {
                                        hour12: false,
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    }),
                                    onChange: (e)=>handleUpdateProtectedTime(protectedTimeDayDict[protectedTimeKey], e)
                                })
                            }),
                            /*#__PURE__*/ _jsx(Flex, {
                                sx: classes['.reasonPastContainer'],
                                children: /*#__PURE__*/ _jsx(Select, {
                                    id: "reason",
                                    disabled: dayEditDisabled[protectedTimeDayDict[protectedTimeKey].day.toLowerCase()],
                                    onChange: (e)=>handleUpdateProtectedTime(protectedTimeDayDict[protectedTimeKey], e),
                                    sx: classes['.reasonPastSelect'],
                                    value: protectedTimeDayDict[protectedTimeKey].reason,
                                    children: statusList.rowValues.map((status)=>{
                                        return /*#__PURE__*/ _jsx("option", {
                                            id: "statusReason",
                                            value: status.Reasons,
                                            children: status.Reasons
                                        });
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Flex, {
                                sx: classes['.durationPast'],
                                children: /*#__PURE__*/ _jsx(Input, {
                                    type: 'number',
                                    disabled: dayEditDisabled[protectedTimeDayDict[protectedTimeKey].day.toLowerCase()],
                                    id: "duration",
                                    value: protectedTimeDayDict[protectedTimeKey].duration ?? 0,
                                    onBlur: (e)=>{
                                        handleUpdateProtectedTime(protectedTimeDayDict[protectedTimeKey], e);
                                    },
                                    onChange: (e)=>updateDurationProtectedTimeEntry(protectedTimeDayDict[protectedTimeKey], e)
                                })
                            }),
                            /*#__PURE__*/ _jsx(IconButton, {
                                variant: "outline",
                                disabled: dayEditDisabled[protectedTimeDayDict[protectedTimeKey].day.toLowerCase()],
                                "aria-label": "delete-icon",
                                sx: classes['.deleteButton'],
                                icon: /*#__PURE__*/ _jsx(BiomeIcon, {
                                    iconName: IconName.Trash,
                                    titleText: "Delete"
                                }),
                                onClick: ()=>handleDeleteProtectedTime(protectedTimeDayDict[protectedTimeKey])
                            })
                        ]
                    }),
                    checkProtectedTimeOverlap(protectedTimeDayDict[protectedTimeKey]) ? /*#__PURE__*/ _jsx(Flex, {
                        sx: classes['.durationOverlapWarning'],
                        children: /*#__PURE__*/ _jsx(Text, {
                            sx: classes['.durationOverlapWarningText'],
                            children: "It looks like this block of time overlaps another one."
                        })
                    }) : ''
                ]
            });
        })
    });
};
export { ProtectedTimeList };
